<h1 mat-dialog-title>Select Process</h1>
<div mat-dialog-content></div>
<mat-card>
  <mat-card-content>
    <mat-form-field>
      <input matInput placeholder="Process" [(ngModel)]="term">
    </mat-form-field>
    @for (item of items | filter: term; track item; let i = $index) {
      <div>
        <mat-checkbox class="remember-margin" [checked]="item.selected" (change)="processCheck($event.checked,i)">{{item.processName}}</mat-checkbox>
      </div>
    }
  </mat-card-content>
</mat-card>
<div mat-dialog-actions>
  <button mat-button color="cancel" (click)="close()">CLOSE</button>
  <button mat-button color="primary" (click)="save()">OK</button>
</div>